import { Component, OnInit } from '@angular/core';
import { VehicleArchive } from '../../../api/transportvisualization/transportvisualization.model';
import { PagedContentConfiguration, PagedContentType, TableColumnDefinition, DetailLayout, DetailLayoutItemProvider, DataSetDefinitionConverterService, DialogService } from '@sdbn/common';
import { DataType } from '@sdbn/common-essential';
import { VehicleArchiveAdministrationAPIService } from '../../../api/transportmanagement/VehicleArchiveAdministration.service';

@Component({
  selector: 'yard-vehicle-archive-administration',
  standalone: false,
  templateUrl: './vehicle-archive-administration.component.html',
  styleUrl: './vehicle-archive-administration.component.scss',
})
export class VehicleArchiveAdministrationComponent implements OnInit {

  data = new Array<VehicleArchive>();

  configuration = new PagedContentConfiguration({
    columns: [
      new TableColumnDefinition({
        dictionaryKey: 'numberplate',
        type: DataType.STRING,
        identifier: 'numberplate'
      })

    ],
    itemDataAccessor: {
      getTitle: (item: any) => item['numberplate'],
      getSubtitle: (item: any) => null,
      getIcon: (item: any) => null
    },
    desktopType: PagedContentType.SIDE_TABLE_SINGLE,
    mobileType: PagedContentType.ICON_MENU_SINGLE
  });



  detailLayout = new DetailLayout({ "sequences": [{ "allowFolding": false, "showTitle": false, "blocks": [{ "showTitle": false, "columnCount": 1, "rowCount": 3, "columnWidths": [100], "cells": [{ "column": 1, "row": 1, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "numberplate", "key": "numberplate", "width": 100 }] }, { "column": 1, "row": 2, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "note", "key": "note", "width": 100 }] }, { "column": 1, "row": 3, "colSpan": 1, "rowSpan": 1, "fields": [{ "id": "cabotageWhitelisted", "key": "cabotageWhitelisted", "reference": null, "width": 33 }, { "id": "whitelisted", "key": "whitelisted", "width": 33 }, { "id": "blocked", "key": "blocked", "reference": null, "width": 33 }] }] }] }] });
  detailLayoutItemProvider: DetailLayoutItemProvider;
  attributes = [{ "id": "2d69d806-a24d-45c0-a5dd-33f212a1fd97", "key": "blocked", "type": "BOOLEAN", "precision1": null, "precision2": null, "enumId": null, "lookupId": null }, { "id": "3ce0e95a-9ff6-48fa-bc7d-4bf7aa44900a", "key": "numberPlateNormalized", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }, { "id": "5b366198-373e-47c2-8b04-57e974f08860", "key": "cabotageWhitelisted", "type": "BOOLEAN", "precision1": null, "precision2": null, "enumId": null, "lookupId": null }, { "id": "603a1328-4a2a-4ea7-9869-162dfa462c27", "key": "note", "type": "TEXT", "precision1": null, "precision2": null, "enumId": null, "lookupId": null }, { "id": "85c3bf9f-a545-4678-b26a-3ea67aed1658", "key": "whitelisted", "type": "BOOLEAN", "precision1": null, "precision2": null, "enumId": null, "lookupId": null }, { "id": "aa408614-a531-4a0c-b21d-ab46fd82d751", "key": "numberplate", "type": "STRING", "precision1": 255, "precision2": null, "enumId": null, "lookupId": null }];

  currentSelectedVehicleArchive?: VehicleArchive = undefined;
  currentVehicleArchive?: VehicleArchive = undefined;

  isLoading = false;

  constructor(
    private tctaService: VehicleArchiveAdministrationAPIService,
    private dataSetDefinitionConverterService: DataSetDefinitionConverterService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {

    this.detailLayoutItemProvider = this.dataSetDefinitionConverterService.createDetailLayoutItemProvider(this.attributes, 'common.processing.entity.process-step', false);

    this.loadData();

  }

  public onAddRequested($event: any) {
    this.currentVehicleArchive = new VehicleArchive();
  }

  public onDeleteRequested($event: any) {
    this.dialogService.showConfirm().afterClosed().subscribe(result => {
      this.tctaService.delete(this.currentVehicleArchive).subscribe(() => {
        this.currentSelectedVehicleArchive = undefined;
        this.currentVehicleArchive = undefined;
        this.loadData();
      })
    })
  }

  public saveVehicleArchive(): void {
    if (this.currentVehicleArchive) {
      this.tctaService.save(this.currentVehicleArchive).subscribe(() => {
        this.loadData();
      });
    }
  }

  public cancelEditing(): void {
    this.currentSelectedVehicleArchive = undefined;
    this.currentVehicleArchive = undefined;
    this.loadData();
  }

  public onSelectionChanged(vehicleArchive: any) {
    this.currentSelectedVehicleArchive = vehicleArchive as VehicleArchive;
    this.tctaService.get(vehicleArchive.id).subscribe(theme => {
      this.currentVehicleArchive = theme;
    });
  }

  private loadData() {
    this.isLoading = true;
    this.tctaService.getAll().subscribe(result => {
      this.data = result.values;
      this.isLoading = false;
    });
  }
}
